import React from 'react';
import loadable from '@loadable/component';
import { Route, Switch } from 'react-router-dom';

import Load from './common/Load';

const NotFound = loadable(() => import('./user/NotFound'), { ssr: true });
const AdminRoutines = loadable(() => import('./RoutesAdmin'), { ssr: true });
const UserRoutines = loadable(() => import('./RoutesUser'), { ssr: true });

const ampPrefix = (amp) => (amp ? '/amp' : '');

const generateRoutes = (amp) => [
  <Route key={`${ampPrefix(amp)}/not-found`} path={`${ampPrefix(amp)}/not-found`} component={NotFound} />,
  <Route key={`${ampPrefix(amp)}/workout-center/:type/:id`} path={`${ampPrefix(amp)}/workout-center/:type/:id`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/:type/exercises/:name/:page(\\d+)`} path={`${ampPrefix(amp)}/:type/exercises/:name/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/:type/exercises/:name`} path={`${ampPrefix(amp)}/:type/exercises/:name`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/:type/exercises`} path={`${ampPrefix(amp)}/:type/exercises`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/map/:type/:id(\\d+)/:name/photo/:photoId`} path={`${ampPrefix(amp)}/map/:type/:id(\\d+)/:name/photo/:photoId`} component={Load} />,
  <Route key={`${ampPrefix(amp)}1`} path={`${ampPrefix(amp)}/map/:type/:id(\\d+)/:name`} component={Load} />,
  <Route key={`${ampPrefix(amp)}2`} path={`${ampPrefix(amp)}/map/gyms/:country/:area/:city`} component={Load} />,
  <Route key={`${ampPrefix(amp)}3`} path={`${ampPrefix(amp)}/map/gyms/:country/:area`} component={Load} />,
  <Route key={`${ampPrefix(amp)}4`} path={`${ampPrefix(amp)}/map/gyms/:country`} component={Load} />,
  <Route key={`${ampPrefix(amp)}5`} path={`${ampPrefix(amp)}/map/results/:result/:address`} component={Load} />,
  <Route key={`${ampPrefix(amp)}6`} path={`${ampPrefix(amp)}/:type(gyms|exercise)/:id(\\d+)/:name/photo/:photoId`} component={Load} />,
  <Route key={`${ampPrefix(amp)}7`} path={`${ampPrefix(amp)}/:type(gyms|exercise)/:id(\\d+)/:name`} component={Load} />,
  <Route key={`${ampPrefix(amp)}8`} path={`${ampPrefix(amp)}/:type(gyms|exercise)/:id(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}9`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country/:area/:city/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}10`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country/:area/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}11`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country/:area/:city`} component={Load} />,
  <Route key={`${ampPrefix(amp)}12`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}13`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country/:area`} component={Load} />,
  <Route key={`${ampPrefix(amp)}14`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)/:country`} component={Load} />,
  <Route key={`${ampPrefix(amp)}15`} path={`${ampPrefix(amp)}/:type(gyms[^/]*)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}16`} path={`${ampPrefix(amp)}/results/:result/:address/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}17`} path={`${ampPrefix(amp)}/results/:result/:address`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/:type(movie|person|genre|year|workout-center)/:page(\\d+)`} path={`${ampPrefix(amp)}/:type(movie|person|genre|year|workout-center)/:page(\\d+)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}/:type(movie|person|genre|year|workout-center)`} path={`${ampPrefix(amp)}/:type(movie|person|genre|year|workout-center)`} component={Load} />,
  <Route key={`${ampPrefix(amp)}`} path={`${ampPrefix(amp)}`} exact component={Load} />,
];

const Routes = (
  <Switch>
    <Route path="/admin" component={AdminRoutines} />
    <Route path="/user" component={UserRoutines} />
    {generateRoutes(true)}
    {generateRoutes()}
  </Switch>
);

export default Routes;
